
import { Vue, Component } from "vue-property-decorator";
import request from "@/lib/request/request";
import Auth from "@/lib/common/auth";
// import TagEdit from "./components/tag-edit.vue";
import ApplicationRule from "./components/application-rule.vue";
import ExamList from "@/lib/model/exam/exam";
import ExamListForm from "@/lib/form/exam/ExamListForm";

@Component({
  components: {
    // TagEdit,
    ApplicationRule
  }
})
export default class TagList extends Vue {
  form = {
    examName: ""
  };
  examId = 0;
  applicationRule = "";
  examForm = new ExamListForm();
  visible = false;
  examList = [{ value: "0", label: "0" }];
  tableData: any = [];
  page = 1;
  pageSize = 10;
  total = 0;

  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  created() {
    if (this.setWeb) {
      this.getList();
      this.getExamList();
    } else {
      this.$router.replace("/dash");
    }
  }

  async getExamList() {
    this.examForm = new ExamListForm();
    this.examForm.companyId = parseInt(Auth.companyId);
    this.examForm.page = 1;
    this.examForm.pageSize = 10000;
    this.examForm.nameOrRemark = "";
    const res = await ExamList.getList(this.examForm);
    console.log(res);
  }

  async getList() {
    const res = await request.post("/aiExam/applicationRule/list", {
      companyId: Auth.companyId,
      examName: this.form.examName,
      page: this.page,
      pageSize: this.pageSize
    });
    this.total = res.data.data.count;
    this.tableData = res.data.data.list;
  }

  getInfo(row: any) {
    const arr: any = [];
    row.applicationRule.matchRuleRoot?.subList.forEach((el: any) => {
      let san = "";
      let value = "";
      const keys = [
        "cvArgName",
        "dimensionGroupName",
        "dimensionName",
        "paramName",
        "questionId"
      ];
      keys.forEach(key => {
        if (el.detail && el.detail[key]) {
          san += el.detail[key];
        }
      });
      if (
        Array.isArray(el.detail.valueRange) &&
        el.detail.valueRange.length === 2
      ) {
        value =
          "[" + el.detail.valueRange[0] + "," + el.detail.valueRange[1] + ")";
      } else {
        value = el.detail.valueInt || el.detail.valueStrings;
      }
      arr.push(
        `${el.detail.attribute}:${san ? san : ""}:${
          el.detail.relationship
        }:${value}`
      );
    });
    return arr.join("\n\r");
  }

  addTag() {
    this.examId = 0;
    this.applicationRule = "";
    this.visible = true;
  }

  delTag(row: any) {
    console.log(row);
    this.$confirm("是否删除该规则标签?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      await request.post("/aiExam/applicationRule/delete", {
        companyId: Auth.companyId,
        examId: row.exam.examId,
        applicationRuleId: row.applicationRule.applicationRuleId
      });
      this.$message.success("成功");
      this.getList();
    });
  }

  editTag(row: any) {
    console.log(row);
    this.examId = row.exam.examId;
    this.applicationRule = row.applicationRule;
    this.visible = true;
  }
}
